/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import { isMobile } from "react-device-detect";
import { toast } from "react-toastify"; //토스트(toast)
import axios from "axios";
import moment from "moment";
import { Modal } from "react-responsive-modal";
import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import "react-confirm-alert/src/react-confirm-alert.css";
import "../../css/confirm.css";

class Event202303_ichbangi extends Component {
  state = {
    show: false,
    msg: "",
  };
  _onClose = () => {
    const { setEventIdx } = this.props;
    setEventIdx(0);
  };
  _inviteAgree = () => {
    const { loginId } = this.props;
    if (loginId === null || loginId === undefined || loginId === "") {
      confirmAlert({
        title: "로그인 후 응모하실 수 있습니다.",
        // message: "로그인 후 응모하실 수 있습니다.",
        buttons: [
          {
            label: "확인",
          },
        ],
      });
    } else {
      confirmAlert({
        title: "당첨 안내를 위한 개인 정보 수집 및 이용에 동의하십니까?",
        // message: "로그인 후 응모하실 수 있습니다.",
        buttons: [
          {
            label: "예",
            onClick: () => {
              setTimeout(() => {
                this._invite();
              }, 500);
            },
          },
          {
            label: "아니오",
            onClick: () => {
              setTimeout(() => {
                confirmAlert({
                  title: "응모가 취소되었습니다.",
                  // message: "로그인 후 응모하실 수 있습니다.",
                  buttons: [
                    {
                      label: "확인",
                    },
                  ],
                });
              }, 700);
            },
          },
        ],
      });
    }
  };
  _invite = async () => {
    const { apiUrl, loginId } = this.props;
    if (loginId === null || loginId === undefined || loginId === "") {
      confirmAlert({
        title: "로그인 후 응모하실 수 있습니다.",
        // message: "로그인 후 응모하실 수 있습니다.",
        buttons: [
          {
            label: "확인",
          },
        ],
      });
    } else {
      const dday = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      // console.log(dday);
      if (dday >= "2023-03-23 10:00:00" && dday <= "2023-03-31 23:59:59") {
        const result = await this._inviteApi();
        const intReturn = result.data[0].intReturn;

        if (intReturn === 0) {
          // alert(
          //   "정상적으로 초대에 응모 되었습니다./n응모해 주셔서 감사합니다."
          // );
          confirmAlert({
            title:
              "정상적으로 초대에 응모 되었습니다. 응모해 주셔서 감사합니다.",
            // message: "로그인 후 응모하실 수 있습니다.",
            buttons: [
              {
                label: "확인",
              },
            ],
          });
        } else if (intReturn === -2) {
          // alert(
          //   "이미 응모하신 아이디입니다. 아이디당 한번만 응모가 가능합니다."
          // );
          confirmAlert({
            title:
              "이미 응모하신 아이디입니다. 아이디당 한번만 응모가 가능합니다.",
            // message: "로그인 후 응모하실 수 있습니다.",
            buttons: [
              {
                label: "확인",
              },
            ],
          });
        } else if (intReturn === -3) {
          confirmAlert({
            title: "멤버십 회원만 응모가 가능합니다.",
            // message: "로그인 후 응모하실 수 있습니다.",
            buttons: [
              {
                label: "확인",
              },
            ],
          });
          // alert("멤버십 회원만 응모가 가능합니다.");
        } else if (intReturn === -1) {
          confirmAlert({
            title: "애니플러스 회원만 응모가 가능합니다.",
            // message: "로그인 후 응모하실 수 있습니다.",
            buttons: [
              {
                label: "확인",
              },
            ],
          });
          // alert("애니플러스 회원만 응모가 가능합니다.");
        } else if (intReturn === -4) {
          confirmAlert({
            title: "응모기간 이전 이거나 응모가 마감 되었습니다.",
            // message: "로그인 후 응모하실 수 있습니다.",
            buttons: [
              {
                label: "확인",
              },
            ],
          });
          // alert("응모기간 이전 이거나 응모가 마감 되었습니다.");
        }
      } else {
        confirmAlert({
          title: "응모기간 이전 이거나 응모가 마감 되었습니다.",
          // message: "로그인 후 응모하실 수 있습니다.",
          buttons: [
            {
              label: "확인",
            },
          ],
        });
        // alert("응모기간 이전 이거나 응모가 마감 되었습니다.");
      }
    }
  };
  _inviteApi = () => {
    const { apiUrl, loginId } = this.props;
    return axios
      .post(apiUrl + "/event_202303_ichbangi", {
        params: {
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _cancel = () => {
    confirmAlert({
      title: "응모가 취소되었습니다.",
      // message: "로그인 후 응모하실 수 있습니다.",
      buttons: [
        {
          label: "확인",
        },
      ],
    });
  };
  _onCloseModal = () => {
    this.setState({
      show: false,
    });
  };
  render() {
    const { imgUrl } = this.props;
    const { show, msg } = this.state;

    return (
      <Fragment>
        <div className="event_head">
          <h3>최애의 아이 상영회</h3>
          <button
            type="button"
            className="btnClose"
            onClick={this._onBack}
            style={{ pointer: "cursor" }}
          >
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <Fragment>
            <div>
              <img src={imgUrl + "/img/event/event230313_2/01_1.png"} alt="" />
            </div>
            <div>
              <img
                src={imgUrl + "/img/event/event230313_2/02_1.png"}
                alt=""
                useMap="#map1"
              />
            </div>
          </Fragment>

          <map name="map1">
            <area
              onClick={this._inviteAgree}
              style={{ cursor: "pointer" }}
              shape="rect"
              coords="122, 2993, 815, 3158"
            />
            <area
              onClick={this._cancel}
              style={{ cursor: "pointer" }}
              shape="rect"
              coords="888, 2992, 1576, 3155"
            />
          </map>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202303_ichbangi));
